<template>
	<div class="list">
		<div class="list-tt">十神吉凶</div>
		<div class="list-info" style="display: block;">
			<div class="shishen">
				<div v-for="item in infoHtml" class="shishen-item">
					<h4>{{item.name}}<span :class="item.clas">{{item.type}}</span></h4>
					<p>{{item.desc}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['shishen'],
		data() {
			return {
				infoHtml: '',
				sex: {
					1: '男',
					2: '女'
				},
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				good: [{
						name: "官印相生",
						match: ["正官", "正印"],
						match2: ["正官", "偏印"],
						condition: "",
						desc: "人品端正稳重有修养，易得长辈贵人领导扶持；适合公职、体制、管理岗位，学历高，一生少大波折。"
					},
					{
						name: "杀印相生",
						match: ["七杀", "正印"],
						match2: ["七杀", "偏印"],
						condition: "",
						desc: "有魄力有威严，抗压能力极强；能化压力为权势，适合军警、司法、管理、创业，磨难之中可成大器。"
					},
					{
						name: "食神生财",
						match: ["食神", "正财"],
						match2: ["食神", "偏财"],
						condition: "",
						desc: "头脑灵活有手艺、口才与专业能力；靠技术、副业、技艺生财，财运稳健，越老越有福报。"
					},
					{
						name: "伤官生财",
						match: ["伤官", "正财"],
						match2: ["伤官", "偏财"],
						condition: "身旺",
						desc: "聪明机灵点子多，敢闯敢拼善于捕捉商机；适合创业、销售、电商、投资，不喜被管束，适合自主经营。"
					},
					{
						name: "财官双美",
						match: ["正财", "正官"],
						match2: [],
						condition: "身旺",
						desc: "事业财运双双稳健，名利兼得；既有社会地位又有积蓄，一生安稳福气厚重，职场容易稳步晋升。"
					},
					{
						name: "食神制杀",
						match: ["食神", "七杀"],
						match2: [],
						condition: "身旺",
						desc: "智勇双全深谙谋略，能以智慧驾驭压力与小人；可掌大权做高管，属于典型大器晚成格局。"
					},
					{
						name: "伤官佩印",
						match: ["伤官", "正印"],
						match2: ["伤官", "偏印"],
						condition: "身旺",
						desc: "才华有度、文武双全；适合文学、艺术、学术、设计等领域，有名气、有修养、受人敬重。"
					},
					{
						name: "比劫助身",
						match: ["比肩", "劫财"],
						match2: [],
						condition: "身弱",
						desc: "人缘好朋友多，遇事易得同辈帮扶；合伙做事有助力，抗压能力强，不会孤立无援。"
					},
					{
						name: "印比相生",
						match: ["正印", "比肩"],
						match2: ["偏印", "劫财"],
						condition: "身弱",
						desc: "贵人有力生扶自身，长辈助力多、根基稳；学业容易有成，身体气场足，多得身边人关照。"
					}
				],
				bad: [{
						name: "伤官见官",
						match: ["伤官", "正官"],
						match2: [],
						condition: "无正财无偏财",
						desc: "伤官见官为祸百端；性格高傲嘴直，容易顶撞领导长辈；职场口舌是非多、岗位变动频繁，感情易倔强争执。"
					},
					{
						name: "枭神夺食",
						match: ["偏印", "食神"],
						match2: [],
						condition: "无比劫无比肩",
						desc: "福气受损、口福不佳，肠胃容易偏弱；性格孤僻多疑、想太多；长辈缘分薄，容易孤独多虑、睡眠质量差。"
					},
					{
						name: "比劫夺财",
						match: ["比肩", "正财"],
						match2: ["劫财", "偏财"],
						condition: "身旺",
						desc: "容易被朋友、熟人借钱不还、合伙分钱不均破财；为人仗义但容易好心吃亏，不宜与人合伙投资。"
					},
					{
						name: "财多身弱",
						match: [],
						match2: [],
						condition: "身弱且正财+偏财>=2",
						desc: "赚钱机会虽多却难以把握，有财难留；求财操心劳碌，容易借贷破财、投资踩坑，只宜安稳打工不宜创业。"
					},
					{
						name: "身弱杀旺",
						match: [],
						match2: [],
						condition: "身弱且七杀>=2 无正印无偏印无食神",
						desc: "从小压力大、多虑焦虑；容易遭小人压制、生活波折多；精神容易内耗，体质偏弱，心态容易压抑。"
					},
					{
						name: "印多身旺",
						match: [],
						match2: [],
						condition: "身旺且正印+偏印>=2",
						desc: "依赖性强、懒散拖延，想得多做得少；贵人太多反而安逸躺平，缺乏上进心，容易原地踏步。"
					},
					{
						name: "官杀混杂",
						match: ["正官", "七杀"],
						match2: [],
						condition: "",
						desc: "事业方向摇摆不定，心性纠结犹豫；职场多变动、选择困难；感情容易复杂纠结，难以专一稳定。"
					},
					{
						name: "财星破印",
						match: ["正财", "正印"],
						match2: ["偏财", "偏印"],
						condition: "身弱",
						desc: "容易为了钱财忽略学业、名声与原则；因财损耗贵人缘分，为生计奔波劳碌，难以安稳求学进修。"
					},
					{
						name: "食伤泄身太过",
						match: [],
						match2: [],
						condition: "身弱且食神+伤官>=3",
						desc: "心思过重、幻想太多，身心容易疲惫；思虑过度内耗大，容易脱离现实，精神与体力都易透支。"
					},
					{
						name: "比劫林立",
						match: [],
						match2: [],
						condition: "身旺且比肩+劫财>=3",
						desc: "性格争强好胜、固执不服输；人际关系易有竞争矛盾，合伙易纠纷、求财多争夺，难得清闲安稳。"
					}
				],
				special: [{
						name: "伤官伤尽",
						match: [],
						match2: [],
						condition: "伤官>=2 正官==0 七杀==0",
						desc: "伤官伤尽最为奇；才华横溢、思路独特，不靠体制靠自身本事立业，技艺、文创、经商皆可成名。"
					},
					{
						name: "从财格",
						match: [],
						match2: [],
						condition: "身弱无根 正财+偏财>=3 正印+偏印==0 比肩+劫财==0",
						desc: "弃命从财格局，商业天赋极强；善于经商理财、聚拢财富，适合投资、贸易、做生意，财运层次很高。"
					},
					{
						name: "从杀格",
						match: [],
						match2: [],
						condition: "身弱无根 七杀>=3 正印+偏印==0 比肩+劫财==0",
						desc: "弃命从杀格局，魄力胆识过人；适合军警、司法、管理、权势行业，能在高压环境中身居高位。"
					},
					{
						name: "从儿格",
						match: [],
						match2: [],
						condition: "身弱无根 食神+伤官>=3 正印+偏印==0 比肩+劫财==0",
						desc: "弃命从儿格局，天赋技艺出众；靠才艺、技术、创意立身成名，一生有福清闲，不靠蛮力谋生。"
					}
				],
				wang: ['', '身弱', '中和', '身旺']
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				let type = this.shishen.type;
				let sex = this.shishen.sex;
				let year = this.shishen.year;
				let month = this.shishen.month;
				let day = this.shishen.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.shishen.time];
				let timeName = this.times[this.shishen.time];
				let shenLv = this.$store.state.shenLv;

				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}

				let tianShen = [bazi.getYearShiShenGan(), bazi.getMonthShiShenGan(), bazi.getTimeShiShenGan()];
				let diShen = [...bazi.getYearShiShenZhi(), ...bazi.getMonthShiShenZhi(), ...bazi.getDayShiShenZhi(), ...bazi.getTimeShiShenZhi()];
				let allShen = [...tianShen, ...diShen];
				let wangLevel = this.wang[shenLv];
				let shenCount = {
					比肩: 0,
					劫财: 0,
					食神: 0,
					伤官: 0,
					正财: 0,
					偏财: 0,
					正官: 0,
					七杀: 0,
					正印: 0,
					偏印: 0
				};

				allShen.forEach(item => {
					if (shenCount.hasOwnProperty(item)) {
						shenCount[item]++
					}
				})
				let hasGen = this.$store.state.hasGen; //身弱无根专用
				this.infoHtml = this.matchShenCombo(allShen, wangLevel, shenCount, hasGen);
				//console.log(this.infoHtml)
			},
			matchShenCombo(allShenList, wangLevel, shenCount, hasGen) {
				const res = [];
				const {
					比肩,
					劫财,
					食神,
					伤官,
					正财,
					偏财,
					正官,
					七杀,
					正印,
					偏印
				} = shenCount;


				// 工具函数：是否包含全部十神
				const hasAll = (arr) => arr.length > 0 && arr.every(s => allShenList.includes(s));
				// 工具函数：是否无某十神
				const noShen = (s) => shenCount[s] === 0;


				// 遍历吉格
				this.good.forEach(item => {
					let ok = false;
					if (hasAll(item.match)) ok = true;
					if (item.match2 && hasAll(item.match2)) ok = true;

					// 附加旺衰条件
					if (item.condition === "身旺" && wangLevel !== "身旺") ok = false;
					if (item.condition === "身弱" && wangLevel !== "身弱") ok = false;

					if (ok) {
						res.push({
							type: "吉格",
							clas:'jige',
							name: item.name,
							desc: item.desc
						});
					}
				});

				// 遍历凶格
				this.bad.forEach(item => {
					let ok = false;
					// 先匹配固定十神组合
					if (hasAll(item.match)) ok = true;
					if (item.match2 && hasAll(item.match2)) ok = true;

					// 解析条件字符串
					const cond = item.condition;
					if (cond) {
						// 无正财无偏财
						if (cond.includes("无正财无偏财")) {
							ok = ok && (正财 === 0 && 偏财 === 0);
						}
						// 无比劫无比肩
						if (cond.includes("无比劫无比肩")) {
							ok = ok && (比肩 === 0 && 劫财 === 0);
						}
						// 身旺
						if (cond.includes("身旺") && wangLevel !== "身旺") ok = false;
						// 身弱
						if (cond.includes("身弱") && wangLevel !== "身弱") ok = false;

						// 财多身弱 身弱且正财+偏财>=2
						if (cond.includes("身弱且正财+偏财>=2")) {
							ok = (wangLevel === "身弱") && (正财 + 偏财 >= 2);
						}
						// 身弱杀旺
						if (cond.includes("身弱且七杀>=2")) {
							ok = (wangLevel === "身弱") && (七杀 >= 2);
							if (cond.includes("无正印无偏印无食神")) {
								ok = ok && (正印 === 0 && 偏印 === 0 && 食神 === 0);
							}
						}
						// 印多身旺
						if (cond.includes("身旺且正印+偏印>=2")) {
							ok = (wangLevel === "身旺") && (正印 + 偏印 >= 2);
						}
						// 食伤泄身太过
						if (cond.includes("身弱且食神+伤官>=3")) {
							ok = (wangLevel === "身弱") && (食神 + 伤官 >= 3);
						}
						// 比劫林立
						if (cond.includes("身旺且比肩+劫财>=3")) {
							ok = (wangLevel === "身旺") && (比肩 + 劫财 >= 3);
						}
					}

					if (ok) {
						res.push({
							type: "凶格",
							clas:'xiongge',
							name: item.name,
							desc: item.desc
						});
					}
				});

				// 遍历特殊变格
				this.special.forEach(item => {
					const cond = item.condition;
					let ok = false;

					// 伤官伤尽
					if (cond.includes("伤官>=2 正官==0 七杀==0")) {
						ok = (伤官 >= 2) && (正官 === 0) && (七杀 === 0);
					}
					// 从财格
					if (cond.includes("身弱无根 正财+偏财>=3")) {
						ok = (wangLevel === "身弱") && !hasGen &&
							(正财 + 偏财 >= 3) &&
							(正印 + 偏印 === 0) &&
							(比肩 + 劫财 === 0);
					}
					// 从杀格
					if (cond.includes("身弱无根 七杀>=3")) {
						ok = (wangLevel === "身弱") && !hasGen &&
							(七杀 >= 3) &&
							(正印 + 偏印 === 0) &&
							(比肩 + 劫财 === 0);
					}
					// 从儿格
					if (cond.includes("身弱无根 食神+伤官>=3")) {
						ok = (wangLevel === "身弱") && !hasGen &&
							(食神 + 伤官 >= 3) &&
							(正印 + 偏印 === 0) &&
							(比肩 + 劫财 === 0);
					}

					if (ok) {
						res.push({
							type: "特殊变格",
							clas:'biange',
							name: item.name,
							desc: item.desc
						});
					}
				});

				return res;
			}
		},
		watch: {
			shishen(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.shishen-item{
		width: 100%;
		line-height: 30px;
		margin-top: 10px;
		background-color: #f3f5f7;
		padding: 20px;
		box-sizing: border-box;
		border-radius: 10px;
	}
	.shishen-item h4{
		font-size: 17px;
		font-weight: normal;
	}
	.shishen-item span{
		font-size: 12px;
		margin-left: 10px;
		padding: 3px 7px;
		border-radius: 3px;
		color: #fff;
	}
	.shishen-item .jige{
		background-color: #28B95E;
	}
	.shishen-item .xiongge{
		background-color: #CC2535;
	}
	.shishen-item .biange{
		background-color: #f3f5f7;
		color: #333;
	}
	.shishen-item p{
		color: #666;
	}
</style>



// WEBPACK FOOTER //
// src/page/shishen.vue